import {getExportFileAddress} from '@/api/admin/member'

export async function exporting(uuid, exportCallback) {
    const {queryDelay, retryTimes} = getDelayAndRetryTimes()

    for (let i = 0; i < retryTimes; i++) {
        await later(queryDelay)

        let result = await getExportFileAddress(uuid);
        if (result.status === 200 && result.data && result.data.data) {
            exportCallback(true)

            window.location = result.data.data
            break
        }
    }
}

function getDelayAndRetryTimes () {
    let queryDelay = 3000
    let retryTimes = 200

    return {queryDelay, retryTimes}
}

function later (delay) {
    return new Promise(function (resolve) {
      setTimeout(resolve, delay)
    })
}